import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import { formatUrl } from "@utils/formatUrl";

let serverUrl = getSecret('SERVER_AUTH_URL');

export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_USER(state, users) {
    state.cached = users
  },
}

export const actions = {
  init({ state, dispatch }) {},

  fetchUsers(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/users/${query}`).then((response) => {
      const users = response.data
      context.commit('CACHE_USER', users)
      return users
    })
  },

  fetchUsersForOptions(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/api/users/for_options/${query}`)
      .then((response) => {
        return response.data
      })
  },

  fetchUsersDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateUsers(context, formData) {
    let promise = null
    if (formData.url) {
      promise = axios.put(formatUrl(formData.url), formData)
    } else {
      promise = axios.post(`${serverUrl}/api/users/`, formData)
    }
    return promise.then((response) => {
      return response.data
    })
  },

  deleteUsers(context, url) {
    let promise = null
    promise = axios.delete(url)
    return promise.then((response) => {
      return response.data
    })
  },

  changePassword(context, formData) {
    let promise = null
    console.log(formData)
    promise = axios.put(`${formatUrl(formData.url)}set_password/`, formData)
    return promise.then((response) => {
      return response.data
    })
  },
  updatePhotos(context, formData) {
    let promise = null
    promise = axios.put(`${formatUrl(formData.get('url'))}set_photo/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return promise.then((response) => {
      return response.data
    })
  },

  // This request is auto-authenticated by app user
  checkIfUserExists(context, username) {
    return axios
      .get(`${serverUrl}/api/users/exists/?search=${username}`, {
        appRequest: true,
      })
      .then((response) => {
        return response.data
      })
  },

  registerUsers(context, formData) {
    // Used for user registration forms
    let promise = null
    if (formData.url) {
      promise = axios.put(formatUrl(formData.url), formData)
    } else {
      promise = axios.post(`${serverUrl}/api/users/register/`, formData, {
        appRequest: true,
      })
    }
    return promise.then((response) => {
      return response.data
    })
  },
}
